import { getDashboardRoute } from '@modules/dashboard/helpers';
import { Button } from '@mui/material';
import { DashboardViewFragment } from 'generated/graphql';
import { Link } from 'react-router-dom';

interface OpenDashboardLinkProps {
  dashboard: Pick<DashboardViewFragment, 'viewToken' | 'title'>;
}

export const OpenDashboardLink = ({ dashboard }: OpenDashboardLinkProps) => {
  return (
    <Button
      component={Link}
      to={getDashboardRoute(dashboard)}
      target="_blank"
      variant="text"
      color="success"
      size="small"
    >
      See&nbsp;Dashboard
    </Button>
  );
};
